

/**************************************************************************
 * Created on Wed Aug 21 2024
 *
 *  # Honeywell Code Usage Policy
 *
 * **Honeywell Source Code Usage Policy Classification:** Highly Confidential
 *
 * [comment]: # (Options for above are "Inner Source", "General Application", "Highly Confidential", "Export Controlled")
 *
 * **This repository has multiple classifications:** Yes
 *
 * [comment]: # (Options for above are "Yes" when subfolders contain a separate policy,"No" when the whole repo has the same policy)
 *
 * **Honeywell confidential - For internal use only.
 *
 * Property of and copyright ownership by Honeywell International Inc. and/or its affiliates.
 *
 * Use of source code must follow all Honeywell policies including the [HCE Source Code Access Policy](http: //go.honeywell.com/hce-code-access-policy).
 *
 * External use or distribution prohibited without written approval per Honeywell policies**
 *
********************************************************************************/

/***
 * 
 * Initialize all axios end point in this file
 * 
 * 
 * Expose only the created axios instance that will help to 
 * call api with method (POST,PUT,GET....)
 * 
 */


import { CommonSearchOption } from "../../model/ApiRequestsResponse";
import { createAsionInstance } from "../axios/axios-instance";






export const SEARCH = 'search';
export const PIM = 'pim';
export const CUSTOMER='customer';
export const APM = 'apm';
export const GLUE = 'dss';
export const INDSAPI ='indsapi';
export const ReportsService = 'reports-service';

export const PRODUCT_BASE = "pim/products";
export const PRODUCT_TYPE_BASE = "pim/product-types";
export const PRODUCT_DATASOURCE_BASE = "pim/datasources";
export const PRODUCT_CATALOG_BASE = "catalog";
export const STATUS_BASE = "pim/statuses";
export const SUPPORTINGDOCUMENT_TYPE_BASE = "supporting-document-types";
export const OFFERING_BASE = "offerings";
export const AIRCRAFT_MAKE_BASE = "aircraft-makes";
export const AIRCRAFT_MODEL_BASE = "aircraft-models";
export const AIRCRAFT_MAKE_MODEL_BASE = "aircraft-make-model-detail";
export const PRODUCT_SERVICE = "product-service";
export const ATTRIBUTE_BASE = "attributes";
export const ATTRIBUTE_VALUE_BASE = "attribute-values"
export const SERVICE_TYPE = "service-types";
export const SEQURITY_CLASS = "apm-security-classes";
export const TECH_PUB = "publications";
export const TECH_PUB_BASE = "technical-publication";
export const PRODUCT_ATTRIBUTE = "product-attributes";
export const PRODUCT_SUPPORTING_DOCS = "product-supporting-docs";
export const PRODUCT_BUNDLE = "bundled-products";
export const TECHNICAL_PUBLICATION = "publications";
export const PRODUCT_CATEGORIZATION = "product-categorization";
export const PRODCT_RECOMENDATION_PACKEGES = "/pim/product/recommendations/packages";
export const PRODCT_RECOMENDATION_AIRCRAFTPACKEGES = "pim/product/recommendations/aircraftPackages";
export const PRODUCT_RECOMMENDATION = "pim/product/recommendations"
export const PRODUCT_INFO="product-info"
export const PRODUCT_RECOMMENDATION_INFO = PRODUCT_RECOMMENDATION + PRODUCT_INFO;
export const BASE_NUMBER = "base-number";
export const COMMON = 'common';





//@ts-expect-error undefined
const BASE_API_SERVICE_URL = window.ENV?.REACT_APP_BASE_URL || '';

//@ts-expect-error undefined
const BASE_API_URL = window.ENV?.REACT_APP_BASE_API || '';

//@ts-expect-error undefined
export const API_TIMEOUT = +(window.ENV?.API_TIMEOUT || "10000");

const baseApiCon = createAsionInstance({
    baseURL: BASE_API_SERVICE_URL,
    timeout: API_TIMEOUT,
});

const baseApiServiceCon = createAsionInstance({
    baseURL: BASE_API_URL,
    timeout: API_TIMEOUT,
});

const PIMBaseApiCon = createAsionInstance({
    baseURL: BASE_API_URL + `/${ PIM }`,
    timeout: API_TIMEOUT,
});
const customerBaseUrl = createAsionInstance({
    baseURL: BASE_API_URL + `/${ CUSTOMER }`,
    timeout: API_TIMEOUT,
});
const ReportsBaseUrl = createAsionInstance({
    baseURL: BASE_API_URL + `/${ ReportsService }`,
    timeout: API_TIMEOUT,
});

const APMBaseApiCon = createAsionInstance({
    baseURL: BASE_API_URL + `/${ APM }`,
    timeout: API_TIMEOUT,
});
const COMMONBaseApiCon = createAsionInstance({
    baseURL: BASE_API_URL + `/${COMMON}`,
    timeout: API_TIMEOUT,
});
const INDSApiCon = createAsionInstance({
    baseURL: BASE_API_URL + `/${ INDSAPI }`,
    timeout: API_TIMEOUT,
});
export const BaseApi = {
    baseApiCon,
    PIMBaseApiCon,
    baseApiServiceCon,
    ReportsBaseUrl,
    customerBaseUrl,
    APMBaseApiCon,
    COMMONBaseApiCon,
    INDSApiCon
};

export const defaultCommonSearch = {
    search: "",
    sortOrder: 0,
    sortField: "",
    searchByField: ""
} as CommonSearchOption;